export default "__VITE_ASSET__DufatqYh__"